import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css';
import TopComponent from './top.js'
import HomeComponent from './home.js'
import GranulatorComponent from './granulators.js'
import DziovyklosComponent from './dziovyklos.js'
import PresaiComponent from './presai.js'
import LinijaComponent from './linija.js'
import SmulkintuvaiComponent from './smulkintuvai.js'
import FooterComponent from './footer.js'

class App extends Component {
  componentDidMount(){
    document.title = "Granwood"
  }
  render() {
    return (
      <div className="App">
           <TopComponent/>
            <Router>
              <Route path={"/"} exact={true} component={HomeComponent} />
              <Route path={"/home"} component={HomeComponent} />
              <Route path={"/granulators"} component={GranulatorComponent} />
              <Route path={"/dziovyklos"} component={DziovyklosComponent} />
              <Route path={"/presai"} component={PresaiComponent} />
              <Route path={"/linija"} component={LinijaComponent} />
              <Route path={"/smulkintuvai"} component={SmulkintuvaiComponent} />

            </Router>
            <FooterComponent/>
 
      </div>
    );
  }
}

export default App;
